import React, { useState } from "react"

import { ThemeContext } from "../contexts/ThemeContext"

function Toggler() {
    const { globalTheme, themeIcon, setGlobalTheme, setThemeIcon } = React.useContext( ThemeContext )
    const [, setIcon] = useState("")
    let clickedClass = "clicked"
    const body = document.body
    // const lightTheme = "light"
    // const darkTheme = "dark"
    // let theme
    // let storedIcon

    // theme === lightTheme || theme === darkTheme ? body.classList.add(theme) : body.classList.add(lightTheme)

    const switchTheme = (e) => {
        if ( globalTheme === "light" ) {
            e.target.classList.remove(clickedClass)
            setGlobalTheme( "dark" )
            localStorage.setItem("theme", "dark")
        } else {
            e.target.classList.add(clickedClass)
            setGlobalTheme( "light" )
            localStorage.setItem("theme", "light")
        }

        if ( themeIcon === "sun" ) {
            setThemeIcon( "moon" )
            localStorage.setItem("icon", "moon")
            setIcon("moon")
        } else {
            setThemeIcon( "sun" ) 
            localStorage.setItem("icon", "sun")
            setIcon("sun")
        }

        if ( globalTheme === "light" ) {
            body.classList.add( "dark" )
            body.classList.remove( "light" )
        } else {
            body.classList.add( "light" )
            body.classList.remove( "dark" )
        }

        // if ( globalTheme === "light" ) {
        //     body.classList.replace(darkTheme, lightTheme)
        //     e.target.classList.remove(clickedClass)
        //     localStorage.setItem("theme", "light")
        //     theme = lightTheme
        //     setIcon("sun")
        //     localStorage.setItem("icon", "sun")

        // } else {
        //     body.classList.replace(lightTheme, darkTheme)
        //     e.target.classList.add(clickedClass)
        //     localStorage.setItem("theme", "dark")
        //     theme = darkTheme
        //     setIcon("moon")
        //     localStorage.setItem("icon", "moon")
        // }
    }

    return (
        <div
            className={globalTheme === "dark" ? clickedClass : ""}
            id="toggler"
            onClick={(e) => switchTheme(e)}
        >
            {themeIcon === "sun" ? <div className="sun"></div> : <div className="moon"></div>}
        </div>

    )
}

export default Toggler
